import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kaubamärk

  <span style="color:#85c1dc;">**FI:**</span>
  Kauppamerkki

  <span style="color:#85c1dc;">**RU:**</span>
  Товарный знак
*/
/* @__NO_SIDE_EFFECTS__ */
const m1856 = msg(
  mf`Kaubamärk`,
  mf`Kauppamerkki`,
  mf`Товарный знак`,
)

export { m1856 as 'w.module.product_description.no_brand_link' }